import React from "react";

interface AuthLayoutProps {
  eyebrow: string;
  heading: string;
  children: React.ReactNode;
}

/**
 * Shared two-panel shell for all auth pages (login, forgot-password, reset-password).
 * Left panel: brand lockup (desktop-only).
 * Right panel: compact logo for narrow screens, then eyebrow + heading + page content.
 */
const AuthLayout: React.FC<AuthLayoutProps> = ({ eyebrow, heading, children }) => {
  return (
    <div className="flex min-h-screen bg-bg text-fg">
      {/* Left editorial panel — brand lockup is the hero. Desktop-first; hidden on
          narrow screens where the form panel shows a compact logo instead. */}
      <div
        className="relative hidden lg:flex flex-col flex-[1.35] overflow-hidden border-r border-border p-12"
        style={{
          background: "radial-gradient(circle at 24% 34%, rgba(67,97,238,0.12), transparent 54%)",
        }}
      >
        <div className="flex justify-between font-mono text-[9px] uppercase tracking-[0.18em] text-fg-dim">
          <span className="normal-case">a2z radiology ai</span>
          <span>Boston · MA</span>
        </div>

        <div className="my-auto flex flex-col items-center">
          <img
            src="/images/a2z-logo-dark.png"
            alt="a2z Radiology AI"
            className="h-auto w-[340px] max-w-[80%]"
          />
          <p className="mt-7 max-w-[350px] text-center text-sm leading-relaxed text-fg-muted">
            Sign in to access your worklist.
          </p>
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-sm">
          {/* Compact lockup for narrow screens (left panel hidden) */}
          <img
            src="/images/a2z-logo-dark.png"
            alt="a2z Radiology AI"
            className="mb-8 w-44 lg:hidden"
          />

          <div className="mb-2 font-mono text-[10px] uppercase tracking-[0.16em] text-fg-muted">
            {eyebrow}
          </div>
          <h1 className="mb-6 font-display text-xl font-semibold tracking-[-0.02em]">{heading}</h1>

          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
